import { createContext, useCallback, useEffect } from 'react';

import { useSafeContext } from '../useSafeContext.hook';
import { getSessionId, initializeSessionId } from '../../utils';

export const MFESessionContext = createContext<() => string | undefined>(() => '');
MFESessionContext.displayName = 'MFESessionContext';

function getMFESessionId(storageSessionIdKey?: string | undefined) {
	return getSessionId({ storageSessionIdKey });
}

export function MFESessionContextProvider({
	storageSessionIdKey,
	children,
}: {
	storageSessionIdKey?: string;
	children: React.ReactNode;
}) {
	useEffect(() => {
		initializeSessionId({ storageSessionIdKey });

		return () => {
			if (storageSessionIdKey) {
				sessionStorage.removeItem(storageSessionIdKey);
			}
		};
	}, []);

	const value = useCallback(() => getMFESessionId(storageSessionIdKey), []);

	return <MFESessionContext.Provider value={value}>{children}</MFESessionContext.Provider>;
}

export function useMFESession() {
	return useSafeContext(MFESessionContext);
}
